export const ordersStatusOptions = [
  "Pendientes",
  "En progreso",
  "Finalizadas",
  "Canceladas",
  "Todas",
];
